import React, { useEffect, useState } from 'react';
import { Modal, Button, Divider, Row, Col, Form, Input, notification, Select } from 'antd';
import '../Atoms/Nominee.css';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const baseURL = process.env.REACT_APP_API_URL;
const { Option } = Select;

interface AdminNomineeModalProps {
    visible: boolean;
    onCancel: () => void;
    empData: any;
}

const AdminNomineeModal: React.FC<AdminNomineeModalProps> = ({ visible, onCancel, empData }) => {
    const { instance, accounts } = useMsal();
    const [form] = Form.useForm();
    let activeCampaigndata = null;
    // if (!isNewCampaign) {
    //     activeCampaigndata = empData.responseData;
    //     console.warn("Data of the Campaigns: ", activeCampaigndata[0].campaignName);
    // }

    useEffect(() => {
        if (empData) {
            form.setFieldsValue(empData);
        }
    }, [empData, form]);

    const handleCancel = () => {
        onCancel();
    };

    // Function to compare and get changed fields in the required format
    const getChangedFieldsInPatchFormat = (originalData: any, newData: any) => {
        const patchOperations: any[] = [];
        Object.keys(newData).forEach(key => {
            if (originalData[key] !== newData[key]) {
                patchOperations.push({
                    operationType: 0, // Assuming 0 is for 'replace'
                    path: `/${key}`, // JSON path to the field
                    op: 'replace', // Operation type
                    value: newData[key], // New value for the field
                });
            }
        });

        return patchOperations;
    };
    // Function to get the access token
    const getAccessToken = async () => {
        const res = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        });
        return res.idToken
    }

    //send manual reminders to PM,Unit head and ELT
    const handleApproveReminder = async (Approver: string) => {
        try {
        
            const accessToken = await getAccessToken();
            // Get the form values
            const values = await form.validateFields();
            let to;
            let approverEmailid;
            if(Approver === "PeopleManager"){
                to=0;
                approverEmailid=values.managerEmail;
            }else if(Approver === "FirstLevelApprover"){
                to=1;
                approverEmailid=values.firstLevelApproverEmail;                
            }else if(Approver === "SecondLevelApprover"){
                to=2;
                approverEmailid=values.secondLevelApproverEmailId;
            }else {
                notification.error({ message: "Error sending reminder, Invalid" });
            }
            var postUrl = `${baseURL}/api/notifications/email/approvers/${to}/reminder`;
            // Send reminder to the approver
            await axios.post(postUrl, {
                "to": approverEmailid,
                "comments": "",
                "nomineeName": "",
                "reviewerName": "",
                "IsTeam": "false"
            }, {
                headers: {
                    'Content-Type': 'application/json',
                      Authorization: `Bearer ${accessToken}`
                }
            });
            notification.success({ message: "Reminder sent successfully!" });
        } catch (error) {
            console.error("Reminder failed:", error);
            notification.error({ message: "Error sending reminder." });
        }
    };

    const handleSave = async () => {
        const accessToken = await getAccessToken();
        try {
            // Get the form values
            const values = await form.validateFields();

            // Get the patch operations array
            const patchData = getChangedFieldsInPatchFormat(empData, values);

            if (patchData.length > 0) {
                // Make PATCH request if there are changes
                const response = await axios.patch(`${baseURL}/api/nominations/${empData.id}`, patchData,{
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                notification.success({ message: "Data updated successfully!" });
            } else {
                notification.info({ message: "No changes detected." });
            }
        } catch (error) {
            notification.error({ message: "Error updating data." });
        }
    };
    return (
        <Modal
            title="Nominee Details"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="save" type="primary" onClick={handleSave}>
                    Save
                </Button>,
            ]}
            width={1000}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name="nomineeName"
                            label="Nominee Name"
                            rules={[{ required: true, message: 'Please enter the nominee name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="nomineeEmail"
                            label="Nominee Email"
                            rules={[{ required: true, message: 'Please enter the nominee email' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            name="approvalId"
                            label="Nominee ID"
                            rules={[{ required: true, message: 'Please enter the Nomination ID' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorName"
                            label="Nominator Name"
                            rules={[{ required: true, message: 'Please enter the nominator name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorEmail"
                            label="Nominator Email"
                            rules={[{ required: true, message: 'Please enter the nominator email' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorDesignation"
                            label="Nominator Designation"
                            rules={[{ required: true, message: 'Please enter the nominator Designaton' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorCountry"
                            label="Nominator Country"
                            rules={[{ required: true, message: 'Please enter the nominator Country' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorEmployeeId"
                            label="Nominator Employee ID"
                            rules={[{ required: true, message: 'Please enter the nominator Employee ID' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorGrade"
                            label="Nominator Grade"
                            rules={[{ required: true, message: 'Please enter the nominator Grade' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorLegalEntityName"
                            label="Nominator Legal Entity Name"
                            rules={[{ required: true, message: 'Please enter the nominator Legal Entity Name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="nominatorUnit"
                            label="Nominator Unit"
                            rules={[{ required: true, message: 'Please enter the nominator unit' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="formFields"
                            label="Nominator Citation"
                            rules={[{ required: true, message: 'Please enter the Nominator Citation' }]}
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="nominatorCitation"
                            label="Form Fields"
                            rules={[{ required: true, message: 'Please enter the form fields' }]}
                        >
                            <Input.TextArea rows={4} />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Manager Details */}
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            name="managerName"
                            label="Manager Name"
                            rules={[{ required: true, message: 'Please enter the Manager Name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="managerEmail"
                            label="Manager Email"
                            rules={[{ required: true, message: 'Please enter the Manager Email' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="managerVote"
                            label="Manager Vote"
                            rules={[{ required: true, message: 'Please enter the Manager Vote' }]}
                        >
                            <Select placeholder="Select a Status" style={{ width: '100%' }}>
                                <Option value="Not Reviewed">Not Reviewed</Option>
                                <Option value="Approved">Approved</Option>
                                <Option value="Rejected">Rejected</Option>                                
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button key="reminder" onClick={() => handleApproveReminder("PeopleManager")} type='primary'>
                            Send Reminder
                        </Button>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="managerComments"
                            label="Manager Comments"
                        > <Input.TextArea rows={2} />
                        </Form.Item>
                    </Col>
                </Row>

                {/* First Manager Details */}
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            name="firstLevelApproverName"
                            label="First Level Approver Name"
                            rules={[{ required: true, message: 'Please enter the First Level Approver Name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="firstLevelApproverEmail"
                            label="First Level Approver Email"
                            rules={[{ required: true, message: 'Please enter the First Level Approver Email' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="firstLevelApproverVote"
                            label="First Level Approver Vote"
                            rules={[{ required: true, message: 'Please enter the First Level Approver Vote' }]}
                        >
                            <Select placeholder="Select a Status" style={{ width: '100%' }}>
                                <Option value="Not Reviewed">Not Reviewed</Option>
                                <Option value="Approved">Approved</Option>
                                <Option value="Rejected">Rejected</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button key="reminder" onClick={() => handleApproveReminder("FirstLevelApprover")} type='primary'>
                            Send Reminder
                        </Button>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="firstLevelApproverComments"
                            label="First Level Approver Comments"
                        > <Input.TextArea rows={2} />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Second Manager Details */}
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            name="secondLevelApproverName"
                            label="Second Level Approver Name"
                            rules={[{ required: true, message: 'Please enter the Second Level Approver Name' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="secondLevelApproverEmailId"
                            label="Second Level Approver Email"
                            rules={[{ required: true, message: 'Please enter the Second Level Approver Email' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="secondLevelApproverVote"
                            label="Second Level Approver Vote"
                            rules={[{ required: true, message: 'Please enter the Second Level Approver Vote' }]}
                        >
                            <Select placeholder="Select a Status" style={{ width: '100%' }}>
                                <Option value="Not Reviewed">Not Reviewed</Option>
                                <Option value="Approved">Approved</Option>
                                <Option value="Rejected">Rejected</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button key="reminder" onClick={() => handleApproveReminder("SecondLevelApprover")} type='primary'>
                            Send Reminder
                        </Button>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="secondLevelApproverComments"
                            label="Second Level Approver Comments"
                        > <Input.TextArea rows={2} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
            </Form>
        </Modal>
    );
};

export default AdminNomineeModal;
